import React from "react";
import "./ribbonTag.css";
import classNames from "classnames";

const RibbonTag = (props) => {
  const { text, right, left, sticky, top, bottom } = props;
  return text ? (
    <span
      className={classNames(
        "cr",
        { "cr-right": right },
        { "cr-left": left },
        { "cr-sticky": sticky },
        { "cr-top": top },
        { "cr-bottom": bottom }
      )}
    >
      {text.toUpperCase()}
    </span>
  ) : null;
};

export default RibbonTag;
